import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCheckmark1Small"><Path fillRule="evenodd" clipRule="evenodd" d="M16.6475 7.1141C16.9988 7.33363 17.1055 7.79635 16.886 8.1476L11.5735 16.6476C11.4524 16.8414 11.2495 16.9694 11.0224 16.9953C10.7953 17.0211 10.5688 16.942 10.4072 16.7804L7.21967 13.5929C6.92678 13.3 6.92678 12.8252 7.21967 12.5323C7.51256 12.2394 7.98744 12.2394 8.28033 12.5323L10.8012 15.0531L15.614 7.3526C15.8335 7.00135 16.2962 6.89457 16.6475 7.1141Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Small;
